<template>
   <div>
        <van-tabs @click="ConsoleTit" v-model:active="active" class="home_tab" swipeable>
            <!-- <van-tab title="通知公告" name="通知公告" class="info_content">
                <Authen></Authen>
            </van-tab>
            <van-tab title="业主表决" name="业主表决" class="info_content">
                <Voting></Voting>
            </van-tab>
            <van-tab title="应急公示" name="应急公示"  class="info_content">
                <MeetAn></MeetAn>
            </van-tab> -->
            <van-tab title="通知公告" name='通知公告'>内容 1</van-tab>
            <van-tab title="业主表决" name="业主表决">内容 2</van-tab>
            <van-tab title="应急公示" name="应急公示">内容 3</van-tab>
        </van-tabs>
        <van-button type="success" size="normal" @click="ToImage">跳转返回测试</van-button>
   </div> 
</template>

<script>
// import VueCookie from 'vue-cookie'
export default {
    data(){
        return{
            active:sessionStorage.getItem('active')
        }
    },
    methods:{
        ConsoleTit(){
            console.log(this.active)
            // VueCookie.set('active',this.active,{expires:'15s'})
            sessionStorage.setItem('active',this.active)
        },
        ToImage(){
            this.$router.push({
                path:'/ButText',
            })
        }
    },
    created(){
        // this.active ='通知公告'
    }
}
</script>

<style scoped>

</style>